import { useAppSelector } from 'app/state'
import { useEffect } from 'react'
import { getToken } from 'features/common/api/requests'

export enum AccessTokenType {
  User = 'user',
  Map = 'map'
}

export default function useAccessToken(options?: { enabled?: boolean; type?: AccessTokenType }) {
  const enabled = options?.enabled ?? true
  const type = options?.type

  const accessToken = useAppSelector((state) => {
    switch (type) {
      case AccessTokenType.User:
        return state.common.accessToken
      case AccessTokenType.Map:
        return state.maps.currentMap?.token
      default:
        return state.common.accessToken || state.maps.currentMap?.token
    }
  })

  useEffect(() => {
    // If 'type' is restricted, missing access token is expected. Otherwise,
    // log an error.
    if (enabled && !accessToken && !type) {
      getToken().catch((error) => {
        console.error('useAccessToken: failed to retrieve access token', error)
      })
    }
  }, [enabled, accessToken, type])

  return accessToken
}
